import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { SpeedReadingFooterButtonComponent } from './speed-reading-footer-button/speed-reading-footer-button.component';
import { SpeedReadingFooterComponent } from './speed-reading-footer.component';

@NgModule({
  declarations: [SpeedReadingFooterComponent, SpeedReadingFooterButtonComponent],
  exports: [SpeedReadingFooterComponent, SpeedReadingFooterButtonComponent],
  imports: [CommonModule, DimensionsListenerDirective],
})
export class SpeedReadingFooterModule {}
